import { useQuery } from '@tanstack/react-query';
import { zohoApi } from '../services/api';

/**
 * Liste complète des vendors Zoho Books, cache 5 min côté front (le backend a
 * lui aussi un cache 5 min, donc les hits côté Zoho restent rares).
 */
export function useZohoVendors() {
  return useQuery({
    queryKey: ['zoho-vendors'],
    queryFn: () => zohoApi.vendors(),
    staleTime: 5 * 60_000,
    gcTime: 30 * 60_000,
  });
}
